// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"7f98f4ad","774":"54461271","971":"9a9c0f95"}[chunkId] + ".chunk.js";
};